import * as actionTypes from "./actionTypes";
import {ConsipService} from "../../api/consipService";
import {toastError} from "../../shared/components/toast/Toast";
import ServiceRequestsService from "../../api/serviceRequestsService";

export const getIsCustomerConsip = (customerId) => {
    return (dispatch) => {
        ConsipService.fetchIsCustomerConsip(customerId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_IS_CUSTOMER_CONSIP,
                    value: res.data,
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
    }
}

export const getOrdiniConsipTableData = (customerId) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_ORDINI_CONSIP_TABLE_DATA_AND_LOADING,
            value: true,
            key: 'loading'
        })
        ConsipService.fetchOrdiniConsipList(customerId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_ORDINI_CONSIP_TABLE_DATA_AND_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_ORDINI_CONSIP_TABLE_DATA_AND_LOADING,
                    value: false,
                    key: 'loading'
                })
            })
    }
}

export const getOrdiniConsipDetails = (customerId, idTrattativa) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_ORDINI_CONSIP_DETAILS,
            value: true,
            key: 'loading'
        })
        ConsipService.fetchConsipDetailsHeader(customerId, idTrattativa)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_ORDINI_CONSIP_DETAILS,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_ORDINI_CONSIP_DETAILS,
                    value: false,
                    key: 'loading'
                })
            })
    }
}

export const getOrdiniConsipOfferta = (customerId, idTrattativa) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_ORDINI_CONSIP_DETAILS_OFFERTA,
            value: true,
            key: 'loading'
        })
        ConsipService.fetchConsipDetailsOfferta(customerId, idTrattativa)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_ORDINI_CONSIP_DETAILS_OFFERTA,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_ORDINI_CONSIP_DETAILS_OFFERTA,
                    value: false,
                    key: 'loading'
                })
            })
    }
}

export const getOfferteRowDetails = (customerId, idTrattativa, commercialLabel) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_OFFERTA_ROW_DETAILS,
            value: true,
            key: 'loading'
        })
        ConsipService.fetchOfferteRowDetails(customerId, idTrattativa, commercialLabel)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_OFFERTA_ROW_DETAILS,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_OFFERTA_ROW_DETAILS,
                    value: false,
                    key: 'loading'
                })
            })
    }
}

export const getConsipSimDaAttivare = (customerId, sort, page, size, filter) => {
    const msisdn = filter.msisdn.value ? filter.msisdn.value : null
    const iccId = filter.iccId.value ? filter.iccId.value : null
    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_SIM_DA_ATTIVARE_LOADING,
            value: true,
        })
        ConsipService.fetchSimDaAttivare(customerId, sort, page, size, msisdn, iccId )
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SIM_DA_ATTIVARE,
                    value: res.data,
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_SIM_DA_ATTIVARE_LOADING,
                    value: false,
                    key: 'loading'
                })
            })
    }
}

export const getConsipPlan = (customerId, idTrattativa, serviceType, selectedSims) => {
    const consipPlansDto = {
        customerId,
        idTrattativa,
        serviceType,
        simList: selectedSims.map(a => a.seriale)
    }

    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_CONSIP_PLAN_AND_LOADING,
            value: true,
            key: 'loading'
        })
        ConsipService.fetchConsipPlanByServiceType(consipPlansDto)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_CONSIP_PLAN_AND_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_CONSIP_PLAN_AND_LOADING,
                    value: false,
                    key: 'loading'
                })
            })
    }
}

export const getSimPrimariaTableData = (customerId, filter, page, size, sort) => {
    const msisdn = filter.msisdn.value ? filter.msisdn.value : null
    const iccid = filter.iccId.value ? filter.iccId.value : null

    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_SIM_PRIMARIA_DATA_AND_LOADING,
            value: true,
            key: 'loading'
        })
        ConsipService.fetchSimPrimariaTableData(customerId, msisdn, iccid, page, size, sort)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SIM_PRIMARIA_DATA_AND_LOADING,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_SIM_PRIMARIA_DATA_AND_LOADING,
                    value: false,
                    key: 'loading'
                })
            })
    }
}

export const getSimSecondariaSummary = (customerId, iccid) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_SIM_SECONDARIA_SUMMARY_DATA,
            value: true,
            key: 'loading'
        })
        ConsipService.fetchSimSecondariaSummary(customerId, iccid)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SIM_SECONDARIA_SUMMARY_DATA,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_SIM_SECONDARIA_SUMMARY_DATA,
                    value: false,
                    key: 'loading'
                })
            })
    }
}

export const attivaSimSecondariaRequest = (dtoBody) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.ATTIVA_SIM_SECONDARIA_REQUEST,
            value: true,
            key: 'loading'
        })
        ServiceRequestsService.reportProblem(dtoBody)
            .then((res) => {
                dispatch({
                    type: actionTypes.ATTIVA_SIM_SECONDARIA_REQUEST,
                    value: res.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e.response.data)
                toastError("Si è verificato un errore")
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.ATTIVA_SIM_SECONDARIA_REQUEST,
                    value: false,
                    key: 'loading'
                })
            })
    }
}

export const clearAttivaSecondariaResponse = () => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.ATTIVA_SIM_SECONDARIA_REQUEST,
            value: [],
            key: 'data'
        })
    }
}
